import { AccordionDetails, Grid, TextField, Typography } from '@mui/material';
import React from 'react';

const RecruitmentStatus: React.FunctionComponent<any> = ({ recruitmentStatus, handleCheck, isDisable, disable }) => {
  return (
    <AccordionDetails className="sq-checklist-tab">
      <Grid container className="checklist-radio-actions">
        <Grid item md={12}>
          <Grid container spacing={2} columnSpacing={3}>
            <Grid item md={4}>
              <Typography variant="body1" mt={0.5}>
                Number of Subjects Screened:
              </Typography>
            </Grid>
            <Grid item md={2}>
              <TextField
                name="stdy_imvrp_sub_screen"
                variant="standard"
                value={recruitmentStatus.stdy_imvrp_sub_screen}
                onChange={e => handleCheck(e, 'recruitmentStatus')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 4 }}
                InputLabelProps={{ shrink: recruitmentStatus.stdy_imvrp_sub_screen }}
              />
            </Grid>
            <Grid item md={4}>
              <Typography variant="body1" mt={0.5}>
                Number of Subjects Enrolled/Randomized:
              </Typography>
            </Grid>
            <Grid item md={2}>
              <TextField
                name="stdy_imvrp_sub_enrolled"
                variant="standard"
                value={recruitmentStatus.stdy_imvrp_sub_enrolled}
                onChange={e => handleCheck(e, 'recruitmentStatus')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 4 }}
                InputLabelProps={{ shrink: recruitmentStatus.stdy_imvrp_sub_enrolled }}
              />
            </Grid>
            <Grid item md={4}>
              <Typography variant="body1" mt={0.5}>
                Number of Screen Failures:
              </Typography>
            </Grid>
            <Grid item md={2}>
              <TextField
                name="stdy_imvrp_sub_sf"
                variant="standard"
                value={recruitmentStatus.stdy_imvrp_sub_sf}
                onChange={e => handleCheck(e, 'recruitmentStatus')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 4 }}
                InputLabelProps={{ shrink: recruitmentStatus.stdy_imvrp_sub_sf }}
              />
            </Grid>
            <Grid item md={4}>
              <Typography variant="body1" mt={0.5}>
                Number of Subjects on Treatment:
              </Typography>
            </Grid>
            <Grid item md={2}>
              <TextField
                name="stdy_imvrp_sub_treat"
                variant="standard"
                value={recruitmentStatus.stdy_imvrp_sub_treat}
                onChange={e => handleCheck(e, 'recruitmentStatus')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 4 }}
                InputLabelProps={{ shrink: recruitmentStatus.stdy_imvrp_sub_treat }}
              />
            </Grid>
            <Grid item md={4}>
              <Typography variant="body1" mt={0.5}>
                Number of Subjects in Follow-up:
              </Typography>
            </Grid>
            <Grid item md={2}>
              <TextField
                name="stdy_imvrp_sub_fup"
                variant="standard"
                value={recruitmentStatus.stdy_imvrp_sub_fup}
                onChange={e => handleCheck(e, 'recruitmentStatus')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 4 }}
                InputLabelProps={{ shrink: recruitmentStatus.stdy_imvrp_sub_fup }}
              />
            </Grid>
            <Grid item md={4}>
              <Typography variant="body1" mt={0.5}>
                Number of Subjects Completed:
              </Typography>
            </Grid>
            <Grid item md={2}>
              <TextField
                name="stdy_imvrp_sub_compl"
                variant="standard"
                value={recruitmentStatus.stdy_imvrp_sub_compl}
                onChange={e => handleCheck(e, 'recruitmentStatus')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 4 }}
                InputLabelProps={{ shrink: recruitmentStatus.stdy_imvrp_sub_compl }}
              />
            </Grid>
            <Grid item md={4}>
              <Typography variant="body1" mt={0.5}>
                Number of Subjects Lost to Follow-up:
              </Typography>
            </Grid>
            <Grid item md={2}>
              <TextField
                name="stdy_imvrp_sub_lfup"
                variant="standard"
                value={recruitmentStatus.stdy_imvrp_sub_lfup}
                onChange={e => handleCheck(e, 'recruitmentStatus')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 4 }}
                InputLabelProps={{ shrink: recruitmentStatus.stdy_imvrp_sub_lfup }}
              />
            </Grid>
            <Grid item md={4}>
              <Typography variant="body1" mt={0.5}>
                Number of Subjects Withdrawn:
              </Typography>
            </Grid>
            <Grid item md={2}>
              <TextField
                name="stdy_imvrp_sub_withdraw"
                variant="standard"
                value={recruitmentStatus.stdy_imvrp_sub_withdraw}
                onChange={e => handleCheck(e, 'recruitmentStatus')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 4 }}
                InputLabelProps={{ shrink: recruitmentStatus.stdy_imvrp_sub_withdraw }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AccordionDetails>
  );
};

export default RecruitmentStatus;
